import crudHandlers from "./_crud"

export default (state, action) => {
  const { type, payload, response } = action
  switch (type) {
    case "DELETE_FOOD_EXTRA_SUCCESS":
      const { [payload.id]: deletedItem, ...remainingEntities } = state.entities
      return {
        ...state,
        entities: remainingEntities,
      }

    default:
      state = crudHandlers(state, action, "food_extra")

      return state
  }
}
